import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LibConfig, LibConfigService} from '../lib.config';
import {BehaviorSubject, Observable} from 'rxjs';
import moment from 'moment/moment';

@Injectable({
    providedIn: 'root'
})
export class SystemReportService {
    destination = 'system-reports';

    public paymentSummariesSearchCriteria: Observable<any>;
    private paymentSummariesSearchCriteriaSubject: BehaviorSubject<any>;

    constructor(
        public http: HttpClient,
        @Inject(LibConfigService) public config: LibConfig
    ) {
        const dateSetter = moment();
        dateSetter.set({hour: 0, minute: 0, second: 0, millisecond: 0});
        dateSetter.add(1, 'days');

        const endDate = dateSetter.format();
        dateSetter.subtract(8, 'days');
        const startDate = dateSetter.format();

        this.paymentSummariesSearchCriteriaSubject = new BehaviorSubject<any>({cacheTime: new Date(), duration: 'day', startDate, endDate});
        this.paymentSummariesSearchCriteria = this.paymentSummariesSearchCriteriaSubject.asObservable();
    }

    baseUrl() {
        return this.config.apiUrl + '/' + this.destination;
    }

    getGiftCardLiabilityCsv(organizationId: number, status) {
        const httpOptions = {
            responseType: 'blob' as 'json',
        };

        return this.http.get(`${this.baseUrl()}/organization/${organizationId}/gift-card-liability/csv${!!status
            ? '?status=' + status
            : ''}`, httpOptions);
    }

    getPaymentSummaries(organizationId: number, duration: string, startTime: string, endTime: string) {
        return this.http.get(`${this.baseUrl()}/organization/${organizationId}/payment-summaries?duration=${duration}&startTime=${startTime.replace('+', '%2b')}&endTime=${endTime.replace('+', '%2b')}`);
    }

    getPaymentSummariesTotals(organizationId: number, duration: string, startTime: string, endTime: string) {
        return this.http.get(`${this.baseUrl()}/organization/${organizationId}/payment-summaries-totals?duration=${duration}&startTime=${startTime.replace('+', '%2b')}&endTime=${endTime.replace('+', '%2b')}`);
    }

    getPaymentSummariesCsv(organizationId: number, duration: string, startTime: string, endTime: string) {
        const httpOptions = {
            responseType: 'blob' as 'json',
        };
        return this.http.get(`${this.baseUrl()}/organization/${organizationId}/payment-summaries/csv?duration=${duration}&startTime=${startTime.replace('+', '%2b')}&endTime=${endTime.replace('+', '%2b')}`, httpOptions);
    }

    getPaymentSummariesSearchCriteria(): any {
        const val = this.paymentSummariesSearchCriteriaSubject.getValue();
        const current = new Date();
        const difference = current.getTime() - val.cacheTime.getTime();
        const hoursMilli = 1000 * 60 * 60; // 1 hour
        if (Math.abs(difference) < hoursMilli) {
            val.cacheTime = new Date();
            this.paymentSummariesSearchCriteriaSubject.next(val);
            return val;
        } else {
            const dateSetter = moment();
            dateSetter.set({hour: 0, minute: 0, second: 0, millisecond: 0});
            dateSetter.add(1, 'days');

            const endDate = dateSetter.format();
            dateSetter.subtract(8, 'days');
            const startDate = dateSetter.format();
            const newVal = {cacheTime: new Date(), startDate, endDate};
            this.paymentSummariesSearchCriteriaSubject.next(newVal);
            return newVal;
        }
    }
}
